import { decorators } from "@orange-marmalade/paginate-this";

export default function withFilters(Component) {
  return decorators.decorate(Component, ({ paginator }) => ({
    totalCount: paginator.get("totalCount"),
    filters: paginator.get("filters").toJS()
  }));
}



// WEBPACK FOOTER //
// ./app/modules/shared/decorators/withFilters.js